import { render, staticRenderFns } from "./appVirtualKeyboard.vue?vue&type=template&id=595a6b42"
import script from "./appVirtualKeyboard.vue?vue&type=script&lang=js"
export * from "./appVirtualKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports